const utmSource = {
  alertsList: 'alertsList',
  todoList: 'todoList',
  paymentsOnHold: 'paymentsOnHold'
};

export default utmSource;
